import { render, staticRenderFns } from "./SupportInformation.vue?vue&type=template&id=a14321c2&scoped=true"
import script from "./SupportInformation.vue?vue&type=script&lang=js"
export * from "./SupportInformation.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/account_information.css?vue&type=style&index=0&id=a14321c2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14321c2",
  null
  
)

export default component.exports